export default __webpack_public_path__ + "static/media/alien.82daf2ef.gif";